import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';

interface DeleteButtonProps {
  onDelete: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onDelete }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        style={{ marginTop: '0px', height: 'fit-content' }}
        onClick={handleClickOpen}
      >
        <DeleteIcon fontSize="small" color="inherit" />
        <Typography
          variant="body2"
          display="inline"
          style={{ marginLeft: '5px', whiteSpace: 'nowrap' }}
        >
          削除
        </Typography>
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>確認</DialogTitle>
        <DialogContent>
          <DialogContentText>本当に削除しますか？</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleDelete} color="secondary">
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteButton;
